import { KeyboardEvent } from 'react';

export function useKeyboardClick(callback: () => void): (e: KeyboardEvent) => void;
export function useKeyboardClick(callback: (e: KeyboardEvent) => void): (e: KeyboardEvent) => void;
export function useKeyboardClick(callback: ((e: KeyboardEvent) => void) | (() => void)) {
    return (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (typeof callback === 'function') {
                callback.length > 0 ? (callback as (e: KeyboardEvent) => void)(e) : (callback as () => void)();
            }
        }
    };
}
